module.exports = __webpack_public_path__ + "img/31.59d43247.jpg";